import { PropsWithChildren } from 'react';
import styles from './Title.module.css';

const GraphVerticalBar = ({
  children,
}: PropsWithChildren<any>): JSX.Element => (
  <div className={styles.title}>{children}</div>
);
export default GraphVerticalBar;
